import { NgClass } from '@angular/common';
import { Component, DOCUMENT, Inject } from '@angular/core';
import { environment } from '@ecs-environment';
import { TranslatePipe } from '@ngx-translate/core';
import { TrackClickDirective } from '@os-components';
import { SewButton, SewHeadline, SewInput } from '@sew/ui-components-angular/standalone';
import { ServiceTeaserComponent } from './service-teaser/service-teaser.component';

export enum ServiceType {
    NONE = '',
    AT_SEW = 'I',
    ON_SITE = 'F',
}
@Component({
    selector: 'ecs-request-service',
    templateUrl: './request-service.component.html',
    styleUrls: ['./request-service.component.scss'],
    imports: [
        SewHeadline,
        SewInput,
        SewButton,
        NgClass,
        ServiceTeaserComponent,
        TrackClickDirective,
        TranslatePipe,
    ],
})
export class RequestServiceComponent {
    public ServiceType = ServiceType;
    public selectedService = ServiceType.NONE;
    public serialNumber = '';
    public requestServiceUrl = '';

    public constructor(@Inject(DOCUMENT) private document: Document) {}

    public requestServiceAtSew(): void {
        this.selectedService = ServiceType.AT_SEW;
    }

    public requestServiceOnSite(): void {
        this.selectedService = ServiceType.ON_SITE;
    }

    public requestContactToService = (): void => {
        const openContactButtonEvent = new CustomEvent('openContactButton', {
            bubbles: true,
            composed: true,
        });

        setTimeout(() => {
            this.document.dispatchEvent(openContactButtonEvent);
        });
    };

    public updateSerialNumber(serialNumber: string) {
        this.serialNumber = serialNumber;
        this.updateRequestServiceUrl();
    }

    public clearSelectedService(): void {
        this.selectedService = ServiceType.NONE;
        this.serialNumber = '';
    }

    public updateRequestServiceUrl() {
        this.requestServiceUrl = `${environment.baseURLs.api.domain}/os/c/main.do?viewset=IM&addon=IM&action=PRODUCT_SKIP_PREVIOUS&SEARCH_STRING=${this.serialNumber}&SUBMIT_PRODUCT=X&layout_process_step=40&process=IM&SERVICE_TYPE=${this.selectedService}&DIRECT_LINK=X`;
    }
}
